<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" fill="#E3EEFA" />
    <path d="M10 16L15 21L22.5 12" stroke="black" stroke-width="3" stroke-linecap="round" />
  </svg>
</template>
